import { render } from "./WebsiteSetting.vue?vue&type=template&id=1aeb4d30&scoped=true"
import script from "./WebsiteSetting.vue?vue&type=script&lang=js"
export * from "./WebsiteSetting.vue?vue&type=script&lang=js"

import "./WebsiteSetting.vue?vue&type=style&index=0&id=1aeb4d30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aeb4d30"]])

export default __exports__